import { ArrowRight, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { Lang, t } from "../i18n";
import { leadFormPath, localeRoot } from "../routes";
import { reportLeadEntryConversion } from "../tracking";
import { Footer } from "./Footer";
import { Nav } from "./Nav";
import { Seo } from "./Seo";

export function NotFoundPage({ defaultLang = "en" as Lang }: { defaultLang?: Lang }) {
  const lang = defaultLang;

  return (
    <div className="min-h-screen bg-[#f8f9fa] text-[#100f12] font-sans">
      <Seo lang={lang} page="not-found" />
      <Nav lang={lang} />
      <main className="relative overflow-hidden px-5 pt-36 sm:px-10 lg:pt-40">
        <div
          className="pointer-events-none absolute inset-x-0 top-0 h-[560px]"
          style={{
            background:
              "radial-gradient(circle at 18% 0%, rgba(153, 108, 255, .24), transparent 30%), radial-gradient(circle at 82% 4%, rgba(233, 48, 201, .18), transparent 32%), linear-gradient(180deg, #fff 0%, rgba(248,249,250,.95) 72%, #f8f9fa 100%)",
          }}
        />
        <section className="relative mx-auto flex min-h-[560px] max-w-[980px] flex-col items-center justify-center pb-24 text-center lg:pb-32">
          <div className="inline-flex rounded-full bg-[#f3eefa] px-3 py-1 text-[12px] font-extrabold uppercase tracking-[0.12em] text-[#5223b1]">
            {t(lang, "notFound.badge")}
          </div>
          <div
            className="mt-6 bg-clip-text text-[96px] font-black leading-none tracking-[-0.08em] text-transparent sm:text-[132px] lg:text-[160px]"
            style={{ backgroundImage: "linear-gradient(135deg, #5223b1 0%, #7823b1 45%, #e930c9 100%)" }}
          >
            404
          </div>
          <h1 className="mt-4 text-[34px] font-extrabold leading-tight tracking-[-0.04em] sm:text-[48px]">{t(lang, "notFound.title")}</h1>
          <p className="mx-auto mt-4 max-w-[620px] text-[16px] font-semibold leading-7 text-[#775f78]">{t(lang, "notFound.desc")}</p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-center">
            <Link
              to={localeRoot(lang)}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-xl px-7 text-[14px] font-extrabold text-white no-underline shadow-[0_18px_42px_rgba(120,35,177,.24)] transition-transform hover:-translate-y-0.5"
              style={{ background: "linear-gradient(135deg, #5223b1 0%, #7823b1 48%, #e930c9 100%)" }}
            >
              <Home size={17} />
              {t(lang, "notFound.home")}
            </Link>
            <Link
              to={leadFormPath(lang, undefined, "not_found_contact")}
              onClick={() => reportLeadEntryConversion()}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-xl border border-[#eaddea] bg-white px-7 text-[14px] font-extrabold text-[#2c1a2d] no-underline transition-transform hover:-translate-y-0.5"
            >
              {t(lang, "notFound.contact")}
              <ArrowRight size={17} />
            </Link>
          </div>
        </section>
      </main>
      <div className="relative overflow-hidden bg-[#f8f9fa]">
        <div
          className="pointer-events-none absolute inset-0 opacity-90"
          style={{
            background:
              "radial-gradient(circle at 24% 6%, rgba(153, 108, 255, .13), transparent 30%), radial-gradient(circle at 76% 14%, rgba(233, 48, 201, .10), transparent 28%), linear-gradient(180deg, rgba(248,249,250,.98) 0%, rgba(242,239,249,.92) 100%)",
          }}
        />
        <div className="relative">
          <Footer lang={lang} />
        </div>
      </div>
    </div>
  );
}
